module.exports = __webpack_public_path__ + "static/media/softsiteLogo.5b85fb32.svg";